export const simTabInitialState = {
    data: [],
    page: 0,
    rowsPerPage: 5,
    count: 0,
    sorting: "msisdn,desc",
    loading: false,
    wrenchLoading: false,
    wrenchLoaded: false,
};

export const initialSospeseAndSostitutiveState = {
    data: [],
    page: 0,
    rowsPerPage: 5,
    count: 0,
    sorting: "iccId,desc",
    loading: false,
};

export const simSelectedRowInitialState = {
    collaboratorsForSimList: [],
    tagsForSimList: [],
    firstRenderTags: [],
    offerBulkList: {
        data: [],
        loading: false,
        disassociateActionLoading: false,
    },
};

export const simSuggestionInitialState = {
    menuItems: [],
    loading: false,
};

export const changeIpInitialState = {
    menuItems: [],
    menuItemsLoading: false,
    loading: false,
    error: true,
};

export const changeApnInitialState = {
    apnOptions: [],
    condivisoApnNames: [],
    condivisoVrfNames: [],
    dedicatoApnNames: [],
    sicurezzaCentralizzataApnNames: [],
    fetchLoading: false,
    loading: false,
    error: false,
};

export const initialDetailsState = {
    loading: false,
    error: false,
};

export const initialActiveServiceRequestState = {
    loading: false,
    value: false,
};

export const initialFilterState = {
    numeroDiTelefono: {
        label: "Numero di telefono",
        value: [],
    },
    numeroSeriale: {
        label: "Numero seriale",
        value: [],
    },
    listaDiNumeri: {
        label: "Lista numeri",
        value: [],
    },
    tags: {
        label: "Tag",
        value: [],
    },
    collaborators: {
        label: "Collaboratore",
        value: [],
    },
    classeDiAbilitazione: {
        label: "Classe di abilitazione",
        value: "",
        text: "",
    },
    dataAttivazione: {
        name: "Data di attivazione:",
        from: null,
        to: null,
    },
    dataUltimaModifica: {
        name: "Data ultima modifica:",
        from: null,
        to: null,
    },
    tipologia: {
        label: "Tipologia",
        value: "",
        text: "",
    },
    piano: {
        label: "Piano",
        value: "",
        text: "",
    },
    centroDiFatturazione: {
        label: "Centro di fatturazione",
        value: "",
        text: "",
    },
    centroDiCosto: {
        label: "Centro di costo",
        value: "",
        text: "",
    },
    dualBilling: {
        label: "Dual Billing",
        value: "",
        text: "",
    },
    apnType: {
        label: "Tipo APN",
        value: "",
        text: "",
    },
    authenticationType: {
        label: "Autenticazione",
        value: "",
        text: "",
    },
    trafficShaping: {
        label: "Traffic Shaping",
        value: "",
        text: "",
    },
    numeroOrdine: {
        label: "Numero d’ordine",
        value: "",
        text: "",
    },
    utenzaPortale: {
        label: "Utenza portale FastwebME",
        value: "",
        text: "",
    },
    emailInviata: {
        label: "email inviata",
        value: "",
        text: "",
    },
    simType: {
        label: "Sim Type",
        value: "",
        text: "",
    },
};

export const initialFilterDataState = {
    loading: false,
    error: false,
    collaborators: [],
    tags: [],
    piano: [],
    tipologia: [],
    classeDiAbilitazione: [],
    centroDiCosto: [],
    dualBilling: [],
    apnTypes: [],
    authenticationTypes: [],
    emailInviata: [],
};

export const initialCollaboratorsState = {
    loading: false,
    error: false,
    data: [],
};

export const initialEdhDetailsState = {
    msisdn: "",
    iccId: "",
    dataAttivazione: "",
    tipoServizio: "",
    tipologiaAbbonamento: "",
    loading: false,
    error: false,
    errorStatusCode: 200,
    errorMessage: "",
};

export const initialOcsDetailsState = {
    tipologiaWallet: "",
    opzioniAttive: "",
    piano: "",
    shouldShowRicarica: false,
    buttonModalCode: "",
    creditoOrCanoneLabel: "",
    creditoOrCanoneValue: "",
    offeringId: "",
    loading: false,
    error: false,
    hasPlafondShare: false
};

export const initialExtrasDetailsState = {
    simCollaborators: [],
    tagsForSim: [],
    firstRenderTags: [],
    associatedUser: "",
    loading: false,
    error: false,
};

const countHelperObj = {
    count: 0,
    loading: false,
};

export const initialGroupCountState = {
    attive: countHelperObj,
    inAttivazione: countHelperObj,
    daAttivare: countHelperObj,
    sostitutive: countHelperObj,
    sospese: countHelperObj,
};

export const initialResetPasswordState = {
    buttonLoading: false,
    error: false,
};

export const initialCsvDownloadLoadingState = {
    attive: false,
    inAttivazione: false,
    daAttivare: false,
    sospese: false,
    sostitutive: false,
};

export const simsToBeRechargedInitialState = {
    data: {
        count: 0,
        data: [],
    },
    loading: false,
};

export const addRechargePropertiesInitialState = {
    data: "",
    loading: false,
};

export const eSimDetailsInitialState = {
    data: {
        iccid: "",
        msisdn: "",
        profilo: "",
        esimAbilitata: "",
        eid: "",
        numeroMassimoTooltip: "",
        disponsibleAlDownloadTooltip: "",
        checkTooltip: "",
        esimAbilitataTooltip: "",
        qrCodeString: "",
        numeroMassimo: "",
    },
    error: false,
    loading: false,
};

export const initialESimDistribuzione = {
    statusCode: 200,
    loading: false,
};

export const initialAllSelectedAttive = {
    data: [],
    loading: false,
}
